export default __webpack_public_path__ + "static/media/weblogoWhite.cb5f4381.svg";